<template>
    <div class="min-h-screen bg-black bg-opacity-90">
        <flash :timeout="5000"/>
        <div v-if="data.id == null" class="text-center p-5">
            <div class="bg-white bg-opacity-5 rounded-full mx-auto mt-5 lg:mt-10 px-10 py-2 text-center max-w-sm">
                <span class="text-white font-semibold">ME PARECE QUE O LINK<br>EXPIROU OU É INVÁLIDO</span>
            </div>
            <img class="mx-auto mt-5"
                 :src="require('../../../images/expired_access.png')"
                 width="250"/>
        </div>
        <div v-else>
            <Show v-if="currentStep === 0" :data="data" @accepted="changeStep(1)"/>
            <Form :form.sync="form" :data="data" v-if="currentStep === 1"/>
        </div>
    </div>
</template>
<script>

import Show from "./Show.vue";
import Form from "./Form.vue";
import Confirm from "./Confirm.vue";
import Flash from "../../Helpers/Flash.vue";

export default {
    components: {
        Flash,
        Confirm,
        Form,
        Show
    },
    props: ['data'],
    data() {
        return {
            currentStep: 0,
            form: this.$inertia.form({
                _method: 'PUT',
                name: null,
                federal_document: null,
                email: null,
                phone_number: null,
                occupation: null,
                address: {
                    zip_code: null,
                    street: null,
                    number: null,
                    complement: null,
                    reference: null,
                    neighborhood: null,
                    city: null,
                    state: null
                },
                confirm_terms: false,
                last_id:null
            })
        }
    },
    methods: {
        changeStep: function (item) {
            this.currentStep = item;
        }
    }
}


</script>
